export enum Country {
    AT = 'at',
    DE = 'de',
    CH = 'ch',
    FR = 'fr',
}
